export default __webpack_public_path__ + "static/dev-new-visalia-c8b313d82b804257f1aaa5d5a3d42bd4.jpg";